import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import PreviewInvoiceApproval from "./PreviewInvoiceApproval";

const InvoiceApprovalCreation = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const orgId = JSON.parse(localStorage.getItem("org"));
  const [step, setStep] = useState(1);
  const [sra, setSra] = useState();
  const [fileNames, setFileNames] = useState({
    attachment1Filename: "",
    attachment2Filename: "",
  });
  const [fetching, setFetching] = useState(false);
  const { draftSraId } = useParams();
  const location = useLocation();
  const [noOfApprovers, setNoOfApprovers] = useState();
  const [approvers, setApprovers] = useState({
    approver1: "",
    approver2: "",
    approver3: "",
    approver4: "",
  });
  const isClone = location.state?.clone;
  const cloneData = location.state?.data;
  const [approvalLimit, setApprovalLimit] = useState();
  const [maxApprovalLimit, setMaxApprovalLimit] = useState();

  useEffect(() => {
    const getOrg = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setApprovalLimit(res.data?.iaApprovalLimit || 0);
        setMaxApprovalLimit(res.data?.iaMaxApprovalLimit || 0);
      } catch (error) {
        console.error("Error fetching organization:", error);
      }
    };
    getOrg();
  }, []);

  useEffect(() => {
    if (isClone && cloneData) {
      const getSRA = async () => {
        setFetching(true);
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/invoice-approval/by-id?sraId=${cloneData.id}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSra({
            title: res.data.title || "",
            sapNumber: res.data.sapNumber || "",
            number: res.data.number || "",
            date: res.data.date || "",
            dueDate: res.data.dueDate || "",
            basicAmount: res.data.basicAmount || "",
            taxAmount: res.data.taxAmount || "",
            amount: res.data.amount || "",
            vendorName: res.data.vendorName || "",
            vendorCode: res.data.vendorCode || "",
            po: res.data.po || "",
            dept: res.data.dept || "",
            processedSap: res.data.processedSap || "",
            gl: res.data.gl || "",
            costCenter: res.data.costCenter || "",
            remark: res.data.remark || "",
            justification: res.data.justification || "",
            attachment1: res.data.attachment1 || "",
            attachment2: res.data.attachment2 || "",
          });
          setFileNames({
            ...fileNames,
            attachment1Filename: res.data.attachment1Filename || "",
            attachment2Filename: res.data.attachment2Filename || "",
          });
        } catch (error) {
          console.log(error);
        } finally {
          setFetching(false);
        }
      };
      getSRA();
    }
  }, [isClone, cloneData]);

  const getDraft = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft-invoice-approval?draftSraId=${draftSraId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
      );
      setSra(res.data);
      setNoOfApprovers(res.data.numberOfApprovers);
      setFileNames({
        ...fileNames,
        attachment1Filename: res.data.attachment1Filename || "",
        attachment2Filename: res.data.attachment2Filename || "",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    if (draftSraId !== undefined) {
      getDraft();
    }
  }, [location]);

  return (
    <div style={{ position: "relative" }}>
      {fetching && <div className="loading-div"></div>}
      {step === 1 && (
        <Step1
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
          storedUser={storedUser}
        />
      )}
      {step === 2 && (
        <Step2
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
        />
      )}
      {step === 3 && (
        <Step3
          sra={sra}
          setSra={setSra}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 4 && (
        <Step4
          sra={sra}
          setSra={setSra}
          approvers={approvers}
          setApprovers={setApprovers}
          noOfApprovers={noOfApprovers}
          setNoOfApprovers={setNoOfApprovers}
          setStep={setStep}
          storedUser={storedUser}
          approvalLimit={approvalLimit}
          maxApprovalLimit={maxApprovalLimit}
        />
      )}

      {step === 5 && (
        <PreviewInvoiceApproval
          sra={sra}
          approvers={approvers}
          setStep={setStep}
          storedUser={storedUser}
          fileNames={fileNames}
          noOfApprovers={noOfApprovers}
        />
      )}
    </div>
  );
};

export default InvoiceApprovalCreation;
